import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { c as classNamePropTypes } from './classNames-1ed461aa.js';
import { m as marginPropTypes } from './spacing-0f39ba4a.js';
import { S as SvgIcon } from './SvgIcon-11e6ad98.js';

function IconBug(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.126 10.263a4.5 4.5 0 0 0-6.308.055 4.498 4.498 0 0 0-.062 6.3 4.5 4.5 0 1 0 6.37-6.355zm-5.908-2.64a3.5 3.5 0 1 1 5.565 0c.336.16.662.35.973.571l.57.559 3.468-3.46a1 1 0 0 1 1.412 1.415l-3.577 3.571c.37.659.62 1.376.743 2.117l2.796.002a1 1 0 0 1-.002 2l-2.775-.002a6.509 6.509 0 0 1-.828 2.355l3.643 3.636a1 1 0 0 1-1.412 1.416l-3.504-3.498a6.501 6.501 0 0 1-8.567.082l-3.517 3.51a1 1 0 0 1-1.412-1.415l3.636-3.63a6.472 6.472 0 0 1-.868-2.451l-2.734.002a1 1 0 0 1-.002-2l2.767-.003c.123-.718.367-1.42.732-2.072L2.794 6.803a1 1 0 1 1 1.412-1.416L7.57 8.744a6.49 6.49 0 0 1 1.649-1.12zm1.97-.572a6.537 6.537 0 0 1 1.624 0 1.75 1.75 0 1 0-1.624 0z"
  }));
}
IconBug.propTypes = {
  /** size of icon */
  size: PropTypes.oneOf(['sm', 'smd', 'md', 'mlg', 'lg', 'none']),
  /** CSS class to use, if any */
  className: classNamePropTypes,
  /** color, if not inheriting from parent's text color */
  color: PropTypes.oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white']),
  /** margin for icon, if any */
  margin: marginPropTypes
};
IconBug.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};

export { IconBug as default };
